module.exports = __webpack_public_path__ + "img/gxh-icon.c4e8a216.png";